import * as React from 'react';
import DelayedTextInputContainer from '@af-common/Common/_containers/DelayedTextInputContainer';
import Dimensions from '../../Utils/Dimensions';
import { Button } from '@mui/material';
import AwareComponent from '@af-common/Common/_components/AwareComponent';
import { Trans } from "react-i18next";
import { LockOpen, Lock } from '@mui/icons-material';
import { DOCUMENT_MAX_HEIGHT, DOCUMENT_MAX_WIDTH } from '../../_config/Consts';

export type Props = {
	ratio?: number
	lockRatio?: boolean
	moduleId?: string
	width?: number
	height?: number
	rotation?: number
	documentWidth?: number
	documentHeight?: number
	onWidthChange?: (width: number) => void
	onHeightChange?: (height: number) => void
	onLockRatioChange?: Function
	isAttached?: boolean
	toggleLockRatio?: Function
	updateModule?: (moduleId:string, updates:{[key:string] : any}) => void
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class ModuleDimensions extends AwareComponent<Props> {
	private toggleLock = (e: React.MouseEvent) => {
		this.props.onLockRatioChange(!this.props.lockRatio);
	}

	private stopPropagation = (e:React.MouseEvent) => e.stopPropagation();

	render = () => <>
	<div className="dimensions-wrapper">
		<div className="left-content">
			<Button className={this.props.lockRatio ? "active":""} onMouseDown={this.stopPropagation} onClick={this.toggleLock}>{ this.props.lockRatio ? <Lock /> : <LockOpen /> }</Button>
		</div>
		<div className="right-content">
			<div>
				<DelayedTextInputContainer useUnits step={10} type="number" label={<T>Width</T>} onChange={(value:string) => this.props.onWidthChange(Number(value))} value={String(this.props.width)}/>
			</div>
			<div>
				<DelayedTextInputContainer useUnits step={10} type="number" label={<T>Height</T>} onChange={(value:string) => this.props.onHeightChange(Number(value))} value={String(this.props.height)}/>
			</div>
		</div>
	</div>
	</>
}